module.exports = __webpack_public_path__ + "img/GitHubLogo.da15b83e.png";